import { ArrowBack } from "@mui/icons-material";
import { Grid, Box, Typography, Button, Menu, MenuItem, useTheme } from "@mui/material";
import dayjs from "dayjs";
import CustomIconButton from "packages/novous_web/src/common/components/CustomIconButton";
import DateRangeFilter from "packages/novous_web/src/common/components/DateRange";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import calendar from "packages/novous_web/src/assets/icons/calendar.svg";
import arrow from "packages/novous_web/src/assets/icons/Arrow.svg";
import download from "packages/novous_web/src/assets/icons/download.svg";
import shareCoaching from "packages/novous_web/src/assets/icons/ShareCoaching.svg";


const DriverByAlertDashboardHeader = ({ setDateState, driverName, employeeId, previousSelectedDuration, dateState }: any) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [startDate, setStartDate] = useState(dateState.startDate);
    const [endDate, setEndDate] = useState(dateState.endDate);
    const dateRangeArr = [
        "Today",
        "Yesterday",
        "7 Days",
        "15 Days",
        "30 Days",
        "Custom Range",
    ];
    const scoreData = [
        { name: "Score: 0 - 70", value: 240 },
        { name: "Score: 71 - 90", value: 560 },
        { name: "Score: 91 - 100", value: 202 },
    ];

    const [selectedDuration, setSelectedDuration] = useState(previousSelectedDuration || dateRangeArr[0]);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(
        null
    );

    const getDateRange = (range: string) => {
        const today = dayjs();
        let startDate, endDate;

        switch (range) {
            case "Today":
                startDate = today.format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "Yesterday":
                startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
                endDate = startDate;
                break;
            case "7 Days":
                startDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "15 Days":
                startDate = dayjs().subtract(14, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "30 Days":
                startDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            default:
                startDate = "";
                endDate = "";
        }
        return { startDate, endDate };
    };

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setCalendarAnchorEl(event.currentTarget);
    };



    const handleCalendarClose = () => {
        setShowDatePicker(false);
        // setStartDate("");
        // setEndDate("");

        // setSelectedDuration(dateRangeArr[0]);
        setCalendarAnchorEl(null);
    };

    const handleClose = (value?: string) => {
        console.log("Selected Value:", value);

        if (value) {
            // Only reset dates if changing FROM custom range TO another option
            if (selectedDuration === "Custom Range" && value !== "Custom Range") {
                const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
                setStartDate(newStartDate);
                setEndDate(newEndDate);
            }

            setSelectedDuration(value);
            setShowDatePicker(value === "Custom Range");

            // If selecting Custom Range again, don't reset the dates - keep existing values
            if (value === "Custom Range") {
                setCalendarAnchorEl(anchorEl); // Keep the anchor for the date picker
            }
        }

        setAnchorEl(null);
    };
    useEffect(() => {
        if (selectedDuration === "Custom Range" && startDate !== "" && endDate !== "") {
            setDateState({ startDate: startDate, endDate: endDate, selectedDuration: "Custom Range" })
        }
    }, [selectedDuration])
    return (
        <><Grid container spacing={2} alignItems="center">
            {/* Left Section */}
            <Grid item xs={12} sm={6} md={8}>
                <Box display="flex" flexDirection="column" gap={1}>
                    <button
                        className="text-blue-600 font-medium flex items-center"
                        onClick={() => {
                            // const params = new URLSearchParams();
                            // params.set('startDate', dateState.startDate);
                            // params.set('endDate', dateState.endDate);
                            // params.set('selectedDuration', dateState.selectedDuration);
                            navigate(-1);
                          }}
                    >
                        <ArrowBack className="mr-1" /> Back
                    </button>
                    <Typography
                        variant="h4"
                        className="text-gray-800 font-semibold"
                        sx={{
                            fontFamily: 'Inter Tight',
                            fontWeight: 600,
                            fontSize: '24px',
                            lineHeight: '36px',
                            letterSpacing: '0%',
                            textDecoration: 'underline',
                            textDecorationStyle: 'solid',
                            textDecorationOffset: '0%',
                            textDecorationThickness: '0%',
                        }}
                    >
                        {driverName || 'NA'}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            fontFamily: 'Inter Tight',
                            fontWeight: 400,
                            fontSize: '16px',
                            lineHeight: '24px',
                            letterSpacing: '0%',
                            color: '#767676', // For the label background
                            display: 'inline-block', // Ensures proper alignment
                            padding: '2px 4px', // Optional padding for better appearance
                            // Optional: Ensures text is visible on the background
                        }}
                    >
                        Employee ID:
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontFamily: 'Inter Tight',
                                fontWeight: 400,
                                fontSize: '16px',
                                lineHeight: '24px',
                                letterSpacing: '0%',
                                display: 'inline-block', // Ensures proper alignment
                                marginLeft: '8px', // Adds spacing between label and value
                            }}
                        >
                            {employeeId || 'NA'}
                        </Typography>
                    </Typography>

                </Box>
            </Grid>

            {/* Right Section */}
            {/* <Grid item xs={12} sm={6} md={4}>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={2}
                    sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' } }}
                >
                    
                    {selectedDuration === "Custom Range" && (
                        <Box
                            sx={(theme) => ({
                                backgroundColor: theme.palette.selected,
                                borderRadius: "8px",
                                padding: theme.spacing(1),
                                minWidth: '200px',
                                flexShrink: 0,
                                display: 'flex',
                                alignItems: 'center',
                                height: { xs: "28px", sm: "30px", md: "48px" },
                            })}
                        >
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 700,
                                    lineHeight: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0.5
                                }}
                            >
                                Date Range:
                                <span style={{ color: "#235AF9", whiteSpace: 'nowrap' }}>
                                    {startDate} - {endDate}
                                </span>
                            </Typography>
                        </Box>
                    )}
                    
                    <Button
                        onClick={handleClick}
                        variant="outlined"
                        sx={{
                            height: { xs: "28px", sm: "30px", md: "48px" },
                            px: { xs: 1, sm: 2 },
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 700,
                            display: "inline-flex",
                            alignItems: "center",
                            gap: { xs: 0.5, sm: 1 },
                            borderColor: "#5547dd",
                            backgroundColor: "white",
                            color: "#5547dd",
                            minWidth: 'fit-content',
                            flexShrink: 0,
                            '&:hover': {
                                backgroundColor: '#f5f3ff',
                                borderColor: '#4432cd'
                            }
                        }}
                    >
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            width: '100%'
                        }}>
                            <img
                                src={calendar}
                                alt="Calendar"
                                style={{ width: 18, height: 18, flexShrink: 0 }}
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    lineHeight: 1,
                                    flex: 1
                                }}
                            >
                                {selectedDuration}
                            </Typography>
                            <img
                                src={arrow}
                                alt="Arrow"
                                style={{ width: 18, height: 18, flexShrink: 0 }}
                            />
                        </Box>
                    </Button>
                </Box>
            </Grid> */}
        </Grid>
        {/* <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleClose()}
            PaperProps={{
                sx: {
                    borderRadius: "8px",
                    top: "10px",
                    boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                },
            }}
        >
                {dateRangeArr.map((label) => (
                    <MenuItem
                        key={label}
                        onClick={() => handleClose(label)}
                        sx={(theme) => ({
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                                backgroundColor: theme.palette.action.hover,
                            },
                            backgroundColor: selectedDuration === label ? theme.palette.selected : "transparent",
                        })}
                    >
                        <Typography variant="button" textTransform={"none"}>
                            {label}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu> */}
            {/* <Menu
                anchorEl={calendarAnchorEl}
                open={showDatePicker}
                onClose={handleCalendarClose}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "8px",
                            top: "10px",
                            padding: "0px",
                            boxShadow: "0 6px 10px rgba(0, 0, 0, 0.1)",
                        },
                    },
                }}
            >
                <DateRangeFilter
                    onCancel={handleCalendarClose}
                    onApply={(from, to) => {
                        setStartDate(from);
                        setEndDate(to);
                        setSelectedDuration("Custom Range");
                        setShowDatePicker(false);
                        setCalendarAnchorEl(null);
                    }}
                    initialFrom={startDate}
                    initialTo={endDate} />
            </Menu> */}
        </>
    )
}

export default DriverByAlertDashboardHeader